module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularVietWeb-MediumItalic.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularVietWeb-MediumItalic.woff
 ** module id = 1100
 ** module chunks = 0
 **/